module.exports = __webpack_public_path__ + "assets/img/yl_w_d_i_21.7f94ae9b.jpg";